import { render } from "./moveHouseModal.vue?vue&type=template&id=470d7adc&scoped=true"
import script from "./moveHouseModal.vue?vue&type=script&lang=js"
export * from "./moveHouseModal.vue?vue&type=script&lang=js"

import "./moveHouseModal.vue?vue&type=style&index=0&id=470d7adc&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470d7adc"]])

export default __exports__